import React from 'react';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import { UserRoles } from '@models/user.model';
import DashboardPage from './dashboard';
import { ClientDashboardPage } from './client';

/**
 * Sprint 43, story-223. The `/dashboard` route's entry point. The role branch happens BEFORE
 * `DashboardPage` mounts, so none of its organization-wide hooks (pending bids, approvals,
 * incidents, favorites) ever run for a CLIENT. Every other role gets the existing dashboard.
 */
const DashboardEntry: React.FC = () => {
  const role = useAppSelector((state: RootState) => state.user.role);
  return role === UserRoles.CLIENT ? <ClientDashboardPage /> : <DashboardPage />;
};

export default DashboardEntry;
